var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-send-captcha-wrapper",class:[_vm.veriTipText != '获取验证码' && 'disable-click'],on:{"click":_vm.getCaptcha}},[_vm._v(" "+_vm._s(_vm.veriTipText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }